import Swiper from 'swiper';
import { Keyboard, A11y, EffectFade, Pagination, Autoplay } from "swiper/modules";

export default function initCarousel() {
  console.log('ahaha')

  const swiper = new Swiper('.js-testimonial-carousel', {
    modules: [Keyboard, A11y, Pagination, EffectFade, Autoplay],
    speed: 500,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      notificationClass: 'swiper-notification visually-hidden'
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
}